module.exports = __webpack_public_path__ + "school/img/back.49e425a9.jpg";